module.exports = __webpack_public_path__ + "img/Ellipse.03644b98.png";